module.exports = __webpack_public_path__ + "img/15.a35e1ed6.jpg";